import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stopUILoading } from "../redux/slices/UISlice";
import Loader from "../views/layout/layoutcomponent/loaders";

export const LoadingApp = () => {
    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.ui);
    const [count, setCount] = useState(0);

    const countClicks = () => {
        setCount((c) => c + 1);
        if (count >= 5) {
            dispatch(stopUILoading());
            setCount(0);
        }
    };

    return (
        loading && (
            <div
                onClick={countClicks}
            >
                <Loader/>
            </div>
        )
    );
};
